var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, width: "850", persistent: "" } },
    [
      _c(
        "v-card",
        { attrs: { color: "fill" } },
        [
          _c(
            "v-card-title",
            { class: _vm.title },
            [
              _c("span", [_vm._v("Mass Move Ad Features")]),
              _c(
                "v-col",
                {
                  staticClass: "ml-auto my-auto px-0 pt-0",
                  attrs: { cols: "auto" },
                },
                [
                  _c("span", { staticClass: "text-body-1" }, [
                    _vm._v(
                      " Selected Features: (" +
                        _vm._s(_vm.featureIds.length) +
                        ") "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("v-card-subtitle", { staticClass: "pb-0 mb-0" }, [
            _vm._v("Select a destination ad"),
          ]),
          _c(
            "v-container",
            { staticClass: "ma-0 pa-0 pt-4", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.moveDestinations,
                  loading: _vm.loading,
                  dense: "",
                  height: "384px",
                  "fixed-header": "",
                  "group-by": "id",
                  "item-key": "item_key",
                  "hide-default-footer": "",
                  "footer-props": { "items-per-page-options": [-1] },
                  "items-per-page": -1,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `group.header`,
                      fn: function ({ group, items, headers }) {
                        return [
                          _c(
                            "td",
                            { attrs: { colspan: headers.length } },
                            [
                              _c(
                                "v-row",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "my-auto mx-0",
                                        attrs: {
                                          color: "primary",
                                          "hide-details": "",
                                          disabled:
                                            _vm.moveInProgress ||
                                            (_vm.selectedAds.length > 0 &&
                                              !_vm.selectedAds.includes(group)),
                                          value: group,
                                          ripple: false,
                                        },
                                        model: {
                                          value: _vm.selectedAds,
                                          callback: function ($$v) {
                                            _vm.selectedAds = $$v
                                          },
                                          expression: "selectedAds",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-col", { staticClass: "py-4" }, [
                                    _c("div", [
                                      _c("b", [_vm._v("Destination Ad:")]),
                                      _vm._v(
                                        " " + _vm._s(items[0].ad_name) + " "
                                      ),
                                    ]),
                                    _c("span", { staticClass: "caption" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$dateConfig.formatDate(
                                              items[0].start_date
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm.$dateConfig.formatDate(
                                              items[0].end_date
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.dest_pig_ids`,
                      fn: function ({ item }) {
                        return [
                          item &&
                          item.dest_pig_ids.some((pig_id) => pig_id !== null)
                            ? _c("span", [
                                _vm._v(
                                  " " + _vm._s(item.dest_pig_ids.length) + " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.dest_feature_text`,
                      fn: function ({ item }) {
                        return [
                          item && item.dest_feature_id
                            ? _c("span", [
                                item.dest_feature_text === ""
                                  ? _c("span", [
                                      _c(
                                        "em",
                                        { staticStyle: { color: "#aaa" } },
                                        [_vm._v("(empty)")]
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.dest_feature_text) +
                                          " "
                                      ),
                                    ]),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("v-divider"),
            ],
            1
          ),
          _c(
            "v-toolbar",
            { attrs: { flat: "", color: "fill" } },
            [
              _c("v-col", { attrs: { cols: "auto" } }, [
                _vm.noValidAds
                  ? _c(
                      "span",
                      { staticClass: "warning--text" },
                      [
                        _c("v-icon", { attrs: { color: "warning" } }, [
                          _vm._v("mdi-alert-circle-outline"),
                        ]),
                        _vm._v(" No valid feature destinations found "),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  class: _vm.body,
                  attrs: { disabled: _vm.moveInProgress, text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:value", false)
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text ml-2",
                  class: _vm.body,
                  attrs: {
                    disabled: _vm.moveDisabled,
                    loading: _vm.moveInProgress,
                    color: "warning",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openConfirmDialog.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" Move ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.warningsModal
        ? _c("FeaturePromoWarnings", {
            attrs: {
              multiple: false,
              selectedAd: _vm.selectedAd,
              gappedPromos: _vm.gappedPromos,
              move: true,
            },
            on: { cancel: _vm.closeWarningsModal, confirmAction: _vm.proceed },
            model: {
              value: _vm.warningsModal,
              callback: function ($$v) {
                _vm.warningsModal = $$v
              },
              expression: "warningsModal",
            },
          })
        : _vm._e(),
      _vm.confirmDialog
        ? _c("MassCopyConfirm", {
            attrs: { move: true },
            on: {
              cancel: _vm.closeConfirmDialog,
              confirmAction: _vm.confirmAction,
            },
            model: {
              value: _vm.confirmDialog,
              callback: function ($$v) {
                _vm.confirmDialog = $$v
              },
              expression: "confirmDialog",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }